const layout = () => import('../../internal/dashboard/layoutV2.vue')
const dashboard = () => import('./dashboardpreV2.vue')
const dashboardRandom = () => import('./components/random.vue')

const dashboardpreRoutes = {
  component: layout,
  children: [
    {
      path: '/dashboard',
      name: 'dashboard',
      meta: {
        title: 'dashboard',
        requiresAuth: true,
      },
      component: dashboard,
    },
    {
      path: '/dashboard/random',
      name: 'dashboardRandom',
      meta: {
        title: 'dashboardRandom',
        requiresAuth: true,
      },
      component: dashboardRandom,
    },
  ],
}

export default dashboardpreRoutes
